import { Box, Stack } from "@mui/material";
import { Common, Custom, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useWorkflow } from "contexts/components";
import { forwardRef } from "react";
import { Helpers } from "utils";
import { createStep } from "utils/helpers";

const StepVoting = forwardRef(() => {
  const { updateData, data } = useWorkflow<Workflow.Utils.ContributorType>();
  const { theme } = useTheme();
  const { t } = useApp();

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.contributor.voting_submitted}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.contributor.voting_instruction}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Common.Image src={Helpers.getImage("voting.png")} />
      </Box>
    </>
  );
});

export default createStep<Workflow.Utils.ContributorType>(StepVoting);
